import styled from "styled-components";

// ============================================================================
// Section Header - Used inside each section component
// ============================================================================
export const Header = styled.h3.attrs({})`
  color: var(--main-purple-light);
  padding-left: 0.5rem;
`;

// ============================================================================
// Modal Styles - Used by SectionModal component
// ============================================================================
export const ModalContainer = styled.div.attrs({})`
  width: inherit;
  background: #fff;
  padding: 2rem;
  max-height: -webkit-fill-available;
  overflow-y: scroll;
`;

export const HeaderContainer = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
`;

export const TitleContainer = styled.div.attrs({})``;

export const BodyContainer = styled.div.attrs({})``;

export const CloseBtn = styled.button.attrs({
  className: "text-xl font-medium cursor-pointer bg-transparent border-0",
})`
  color: var(--main-purple-light);
`;

// ============================================================================
// LayerContainer - Wrapper for each section on the report page
// ============================================================================
export const LayerContainer = styled.div.attrs({})`
  margin-top: 2rem;
  border: 1px solid #745082;
  border-radius: 10px;
  padding: 20px;
  page-break-after: always;
`;

export const FilterBtn = styled.button.attrs({
  type: "button",
})`
  cursor: pointer;
  border: 0;
  background-color: var(--main-purple-light);
  color: rgb(255, 255, 255);
  min-height: 3rem;
  border-radius: 5px;
  z-index: 1;

  @media (max-width: 768px) {
    right: -10px;
    top: 9rem;
  }
`;

// ============================================================================
// LayerContent - Content wrapper inside each section
// ============================================================================
export const LayerContent = styled.div.attrs({})`
  margin-top: 3rem;
  min-height: 10rem;
`;

export const IconContainer = styled.div.attrs({})`
  position: absolute;
  cursor: pointer;
  right: 0;
`;

// ============================================================================
// Container/Child - Flexbox layout for table + chart side-by-side
// ============================================================================
export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Child = styled.div<{ flex: string }>`
  flex: ${({ flex }) => flex};
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  position: relative;
  @media (min-width: 769px) {
    width: ${({ flex }) => flex};
  }
`;

// ============================================================================
// FullWidthChartContainer - Chart that spans full width below the table
// ============================================================================
export const FullWidthChartContainer = styled.div`
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
`;

// ============================================================================
// FallContainer - Floating panel (used for quick-view side panels)
// ============================================================================
export const FallContainer = styled.div.attrs({})`
  position: absolute;
  height: 40vh;
  width: 25%;
  right: 0;
  background: #fff;
  padding: 5px;
  opacity: 1;

  @media (max-width: 575.98px) {
    width: 100%;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    width: 50%;
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    width: 50%;
  }

  @media (min-width: 992px) and (max-width: 1380.98px) {
    width: 30%;
  }
`;